import React, { createContext, useContext, useEffect, useState } from "react";

const LangContext = createContext(null);

const dict = {
  id: {
    "nav.home": "Beranda",
    "nav.catalogue": "Tes",
    "nav.about": "Tentang",
    "nav.admin": "Admin",
    "hero.badge": "Refleksi diri • Edukatif • Non-diagnostik",
    "hero.title": "Ruang tenang untuk mengenal diri lebih dalam.",
    "hero.subtitle": "Tes singkat untuk mengenal kepribadian, minat karier, kebiasaan, dan caramu mencintai. Bukan diagnosis, hanya cermin yang jujur.",
    "hero.chip.free": "Gratis",
    "hero.chip.time": "3–5 menit",
    "hero.chip.account": "Tanpa akun",
    "hero.cta": "Mulai Eksplorasi",
    "hero.secondary": "Lihat Cara Kerjanya",
    "home.featured": "Tes Pilihan",
    "home.categories": "Jelajahi berdasarkan tema",
    "home.how": "Cara Kerjanya",
    "home.how.1.title": "Pilih tes",
    "home.how.1.desc": "Telusuri koleksi tes dan pilih yang paling ingin kamu kenali dari dirimu.",
    "home.how.2.title": "Beri persetujuan & isi jawaban",
    "home.how.2.desc": "Tanpa akun, tanpa data pribadi wajib. Anonim, aman, dan bisa kamu hentikan kapan saja.",
    "home.how.3.title": "Terima hasil refleksi",
    "home.how.3.desc": "Skor tiap aspek, penjelasan yang bukan diagnosis, dan saran ringan untuk direnungkan.",
    "home.disclaimer": "Platform ini bertujuan edukatif untuk eksplorasi diri. Bukan diagnosis atau pengganti konsultasi profesional.",
    "home.faq": "Pertanyaan yang sering ditanyakan",
    "cat.title": "Semua Tes",
    "cat.search": "Cari tes...",
    "cat.all": "Semua kategori",
    "cat.empty": "Tidak ada tes yang cocok.",
    "cat.start": "Mulai",
    "cat.min": "menit",
    "cat.questions": "pertanyaan",
    "detail.purpose": "Apa yang diukur",
    "detail.duration": "Estimasi durasi",
    "detail.questions": "Jumlah pertanyaan",
    "detail.age": "Rentang usia",
    "detail.instructions": "Petunjuk",
    "detail.disclaimer": "Catatan Penting",
    "detail.start": "Mulai Tes",
    "detail.consent_before": "Dengan menekan {start}, kamu setuju jawabanmu diproses untuk menghasilkan hasil tes sesuai",
    "detail.consent_link": "Kebijakan Privasi",
    "demo.title": "Data Diri (Opsional)",
    "demo.title_required": "Data Diri",
    "demo.subtitle_required": "Tes ini memerlukan beberapa data diri. Kolom bertanda Wajib harus diisi, sisanya boleh dikosongkan.",
    "demo.subtitle": "Kamu tidak wajib mengisi data pribadi. Semua kolom di sini opsional dan hanya membantu kami memahami konteks jawabanmu.",
    "demo.name": "Nama panggilan",
    "demo.age": "Usia",
    "demo.gender": "Jenis kelamin",
    "demo.education": "Pendidikan terakhir",
    "demo.gender.female": "Perempuan",
    "demo.gender.male": "Laki-laki",
    "demo.gender.other": "Lainnya / tidak ingin menyebut",
    "demo.education.sma": "SMA/SMK",
    "demo.education.d3": "Diploma",
    "demo.education.s1": "Sarjana",
    "demo.education.s2": "Magister",
    "demo.education.s3": "Doktoral",
    "demo.continue": "Mulai menjawab",
    "demo.skip": "Lewati",
    "q.progress": "Pertanyaan {current} dari {total}",
    "q.next": "Lanjut",
    "q.prev": "Sebelumnya",
    "q.submit": "Kirim Jawaban",
    "q.required": "Pertanyaan ini wajib dijawab.",
    "q.autosave": "Tersimpan otomatis",
    "result.title": "Hasil Refleksimu",
    "result.code": "Kode Anonim",
    "result.summary": "Ringkasan",
    "result.dimensions": "Skor Tiap Aspek",
    "result.download": "Unduh / Cetak",
    "result.disclaimer": "Ini adalah refleksi edukatif, bukan diagnosis.",
    "result.back": "Lihat tes lainnya",
    "result.total": "Skor Total",
    "result.dominant": "Kecenderungan utama",
    "account.loading": "Memuat akun…",
    "account.menu": "Menu akun",
    "account.signin": "Masuk",
    "account.register": "Buat akun",
    "account.signout": "Keluar",
    "account.signed_in": "Berhasil masuk",
    "account.signed_out": "Berhasil keluar",
    "account.created": "Akun berhasil dibuat",
    "account.hello": "Halo, {name}",
    "account.profile.name": "Nama",
    "account.profile.birth_date": "Tanggal lahir",
    "account.profile.gender": "Jenis kelamin",
    "account.profile.education": "Pendidikan terakhir",
    "account.profile.occupation": "Pekerjaan",
    "account.profile.marital_status": "Status pernikahan",
    "account.profile.unset": "Pilih…",
    "account.profile.section": "Data diri",
    "account.profile.demographics_help": "Dipakai untuk mengisi otomatis data diri di setiap tes, jadi kamu tidak perlu mengisinya berulang kali.",
    "account.profile.title": "Profil",
    "account.profile.description": "Nama dipakai untuk menyapamu. Data diri dipakai untuk mengisi otomatis data diri di setiap tes.",
    "account.profile.save": "Simpan profil",
    "account.profile.saved": "Profil tersimpan",
    "account.profile.save_error": "Profil tidak dapat disimpan. Periksa isian dan coba lagi.",
    "account.my_results": "Hasil Saya",
    "account.email": "Email",
    "account.password": "Kata sandi",
    "account.confirm_password": "Konfirmasi kata sandi",
    "account.password_help": "Gunakan minimal 12 karakter.",
    "account.working": "Memproses…",
    "account.have_account": "Sudah punya akun?",
    "account.need_account": "Belum punya akun?",
    "account.auth.description": "Simpan dan temukan kembali hasil refleksimu dengan mudah.",
    "account.auth.continue_save": "Masuk atau buat akun untuk melanjutkan penyimpanan hasil ini.",
    "account.auth.optional": "Akun tidak wajib. Kamu tetap bisa mengerjakan tes Mindovia secara anonim.",
    "account.validation.email": "Masukkan alamat email yang valid.",
    "account.validation.password_short": "Kata sandi harus memiliki minimal 12 karakter.",
    "account.validation.password_long": "Kata sandi tidak boleh melebihi 72 byte.",
    "account.validation.password_mismatch": "Konfirmasi kata sandi tidak cocok.",
    "account.error.login": "Email atau kata sandi tidak valid.",
    "account.error.register": "Akun tidak dapat dibuat dengan data tersebut.",
    "account.error.network": "Tidak dapat terhubung. Periksa koneksi dan coba lagi.",
    "account.save.title": "Simpan hasil saya",
    "account.save.cta": "Simpan hasil saya",
    "account.save.description": "Simpan hasil ini ke akun Mindovia agar lebih mudah ditemukan kembali.",
    "account.save.not_premium": "Menyimpan hasil tidak mengubah akses laporan berbayar.",
    "account.save.saving": "Menyimpan…",
    "account.save.saved": "Tersimpan di akunmu",
    "account.save.saved_detail": "Hasil ini sekarang tersedia di Hasil Saya.",
    "account.claim.authentication": "Sesi akun berakhir. Silakan masuk lagi untuk menyimpan hasil.",
    "account.claim.invalid": "Hasil ini sudah tidak bisa disimpan ke akun.",
    "account.claim.conflict": "Hasil ini sudah tersimpan di akun lain.",
    "account.claim.network": "Hasil belum tersimpan. Periksa koneksi dan coba lagi.",
    "account.results.description": "Koleksi pribadi hasil refleksi yang telah kamu simpan.",
    "account.results.empty_title": "Belum ada hasil yang disimpan",
    "account.results.empty_description": "Selesaikan tes di Mindovia lalu pilih “Simpan hasil saya” untuk melihatnya di sini.",
    "account.results.browse": "Jelajahi tes",
    "account.results.untitled": "Tes refleksi",
    "account.results.saved": "Tersimpan",
    "account.results.paid_note": "Akses laporan berbayar tetap dicek terpisah dari daftar ini.",
    "account.results.open": "Buka hasil",
    "account.results.error": "Hasil tersimpan tidak dapat dimuat saat ini.",
    "account.results.retry": "Coba lagi",
    "account.results.remove": "Hapus dari Hasil Saya",
    "account.results.remove_confirm": "Hasil ini akan dihapus dari daftar di akunmu. Hasil anonimnya dan akses laporan berbayar tetap ada.",
    "account.results.remove_action": "Ya, hapus dari daftar",
    "account.results.remove_cancel": "Batal",
    "account.results.removed": "Hasil sudah dihapus dari daftar",
    "account.results.remove_error": "Hasil belum bisa dihapus dari daftar. Coba lagi.",
    "account.forgot.link": "Lupa kata sandi?",
    "account.forgot.title": "Atur ulang kata sandi",
    "account.forgot.description": "Masukkan email akunmu. Jika akun tersedia, kami akan mengirim tautan pengaturan ulang.",
    "account.forgot.submit": "Kirim tautan pengaturan ulang",
    "account.forgot.sent": "Jika akun dengan email tersebut tersedia, instruksi pengaturan ulang akan dikirim.",
    "account.forgot.privacy": "Pesan ini selalu sama untuk melindungi privasi akun.",
    "account.forgot.back": "Kembali untuk masuk",
    "account.reset.title": "Buat kata sandi baru",
    "account.reset.description": "Gunakan kata sandi baru yang hanya kamu pakai untuk akun ini.",
    "account.reset.new_password": "Kata sandi baru",
    "account.reset.submit": "Simpan kata sandi baru",
    "account.reset.success": "Kata sandi diperbarui. Silakan masuk kembali.",
    "account.reset.request_new": "Minta tautan baru",
    "account.verify.title": "Verifikasi email",
    "account.verify.description": "Kami sedang memeriksa tautan verifikasimu.",
    "account.verify.working": "Memverifikasi email…",
    "account.verify.success_title": "Email terverifikasi",
    "account.verify.success": "Alamat email akunmu berhasil diverifikasi.",
    "account.verify.error_title": "Tautan tidak dapat digunakan",
    "account.recovery.error.invalid": "Tautan tidak valid, sudah digunakan, atau telah kedaluwarsa. Minta tautan baru untuk melanjutkan.",
    "account.recovery.error.rate_limit": "Terlalu banyak percobaan. Tunggu sebentar lalu coba lagi.",
    "account.recovery.error.network": "Tautan belum dapat diperiksa. Periksa koneksi dan coba lagi.",
    "account.settings.title": "Pengaturan akun",
    "account.settings.description": "Kelola email, keamanan, hasil tersimpan, dan penghapusan akunmu.",
    "account.settings.email_title": "Email akun",
    "account.settings.verified": "Email telah diverifikasi",
    "account.settings.unverified": "Email belum diverifikasi",
    "account.settings.send_verification": "Kirim email verifikasi",
    "account.settings.verification_sent": "Jika verifikasi masih diperlukan, tautan telah dikirim. Periksa kotak masukmu.",
    "account.settings.security_title": "Keamanan",
    "account.settings.security_description": "Atur ulang kata sandi melalui tautan email aman atau akhiri sesi akun pada perangkat ini.",
    "account.settings.reset_password": "Atur ulang kata sandi",
    "account.settings.saved_title": "Hasil tersimpan",
    "account.settings.saved_description": "Lihat atau hapus hasil yang pernah kamu simpan ke akun.",
    "account.settings.open_results": "Buka Hasil Saya",
    "account.settings.delete_title": "Hapus akun",
    "account.settings.delete_description": "Akunmu akan dihapus dan hasil tersimpan dikeluarkan dari akun. Hasil anonim, transaksi, dan akses laporan berbayar tetap ada dan tidak dipindahkan.",
    "account.settings.current_password": "Kata sandi saat ini",
    "account.settings.delete_confirm": "Aku paham akunku akan dihapus dan hasil tersimpan akan dikeluarkan dari akun ini.",
    "account.settings.delete_action": "Hapus akun saya",
    "account.settings.delete_error": "Akun tidak dapat dihapus. Periksa kata sandi dan coba lagi.",
    "account.settings.deleted": "Akun telah dihapus",
    "admin.login": "Masuk Admin",
    "admin.email": "Email",
    "admin.password": "Kata sandi",
    "admin.signin": "Masuk",
    "admin.dashboard": "Dasbor",
    "admin.instruments": "Instrumen",
    "admin.categories": "Kategori",
    "admin.responses": "Respons",
    "admin.settings": "Pengaturan",
    "admin.logout": "Keluar",
    "footer.note": "Platform edukatif untuk eksplorasi diri.",
  },
  en: {
    "nav.home": "Home",
    "nav.catalogue": "Tests",
    "nav.about": "About",
    "nav.admin": "Admin",
    "hero.badge": "Self-reflection • Educational • Non-diagnostic",
    "hero.title": "A calm space to get to know yourself better.",
    "hero.subtitle": "Short tests about your personality, career interests, habits, and the way you love. No diagnosis, just an honest mirror.",
    "hero.chip.free": "Free",
    "hero.chip.time": "3–5 minutes",
    "hero.chip.account": "No account needed",
    "hero.cta": "Start Exploring",
    "hero.secondary": "See How It Works",
    "home.featured": "Featured Tests",
    "home.categories": "Explore by theme",
    "home.how": "How It Works",
    "home.how.1.title": "Pick a test",
    "home.how.1.desc": "Browse the tests and pick the one you're most curious about.",
    "home.how.2.title": "Agree and answer",
    "home.how.2.desc": "No account and no required personal details. It's anonymous, safe, and you can stop anytime.",
    "home.how.3.title": "Get your results",
    "home.how.3.desc": "Scores for each aspect, a non-diagnostic explanation, and gentle prompts to reflect on.",
    "home.disclaimer": "This platform is for educational self-exploration. It isn't a diagnosis or a substitute for professional help.",
    "home.faq": "Frequently asked questions",
    "cat.title": "All Tests",
    "cat.search": "Search tests...",
    "cat.all": "All categories",
    "cat.empty": "No tests match your search.",
    "cat.start": "Start",
    "cat.min": "min",
    "cat.questions": "questions",
    "detail.purpose": "What it measures",
    "detail.duration": "Estimated duration",
    "detail.questions": "Number of questions",
    "detail.age": "Age range",
    "detail.instructions": "Instructions",
    "detail.disclaimer": "Disclaimer",
    "detail.start": "Start the Test",
    "detail.consent_before": "By pressing {start}, you agree that your answers are processed to produce your results in line with our",
    "detail.consent_link": "Privacy Policy",
    "demo.title": "About You (Optional)",
    "demo.title_required": "About You",
    "demo.subtitle_required": "This test needs a few details about you. Fields marked Required must be filled in; the rest are optional.",
    "demo.subtitle": "You don't have to share any personal details. Everything here is optional and just helps us understand your answers.",
    "demo.name": "Nickname",
    "demo.age": "Age",
    "demo.gender": "Gender",
    "demo.education": "Highest education",
    "demo.gender.female": "Female",
    "demo.gender.male": "Male",
    "demo.gender.other": "Other / prefer not to say",
    "demo.education.sma": "High school",
    "demo.education.d3": "Diploma",
    "demo.education.s1": "Bachelor's",
    "demo.education.s2": "Master's",
    "demo.education.s3": "Doctorate",
    "demo.continue": "Start answering",
    "demo.skip": "Skip",
    "q.progress": "Question {current} of {total}",
    "q.next": "Next",
    "q.prev": "Previous",
    "q.submit": "Submit Answers",
    "q.required": "This question is required.",
    "q.autosave": "Autosaved",
    "result.title": "Your Results",
    "result.code": "Anonymous code",
    "result.summary": "Summary",
    "result.dimensions": "Your Scores by Aspect",
    "result.download": "Download / Print",
    "result.disclaimer": "This is an educational reflection, not a diagnosis.",
    "result.back": "Browse more tests",
    "result.total": "Total score",
    "result.dominant": "Main tendency",
    "account.loading": "Loading account…",
    "account.menu": "Account menu",
    "account.signin": "Sign in",
    "account.register": "Create account",
    "account.signout": "Sign out",
    "account.signed_in": "Signed in",
    "account.signed_out": "Signed out",
    "account.created": "Account created",
    "account.hello": "Hello, {name}",
    "account.profile.name": "Name",
    "account.profile.birth_date": "Date of birth",
    "account.profile.gender": "Gender",
    "account.profile.education": "Highest education",
    "account.profile.occupation": "Occupation",
    "account.profile.marital_status": "Marital status",
    "account.profile.unset": "Select…",
    "account.profile.section": "About you",
    "account.profile.demographics_help": "Used to pre-fill the \"about you\" questions in each test, so you don't have to type them again.",
    "account.profile.title": "Profile",
    "account.profile.description": "Your name is used to greet you. Your details pre-fill the \"about you\" questions in each test.",
    "account.profile.save": "Save profile",
    "account.profile.saved": "Profile saved",
    "account.profile.save_error": "The profile could not be saved. Check the fields and try again.",
    "account.my_results": "My Results",
    "account.email": "Email",
    "account.password": "Password",
    "account.confirm_password": "Confirm password",
    "account.password_help": "Use at least 12 characters.",
    "account.working": "Please wait…",
    "account.have_account": "Already have an account?",
    "account.need_account": "New to Mindovia?",
    "account.auth.description": "Save your results and find them again easily.",
    "account.auth.continue_save": "Sign in or create an account to continue saving this result.",
    "account.auth.optional": "An account is optional. You can still take any Mindovia test anonymously.",
    "account.validation.email": "Enter a valid email address.",
    "account.validation.password_short": "Password must be at least 12 characters.",
    "account.validation.password_long": "Password must not exceed 72 bytes.",
    "account.validation.password_mismatch": "Password confirmation does not match.",
    "account.error.login": "Invalid email or password.",
    "account.error.register": "An account could not be created with those details.",
    "account.error.network": "Unable to connect. Check your connection and try again.",
    "account.save.title": "Save my result",
    "account.save.cta": "Save my result",
    "account.save.description": "Save this result to your Mindovia account so you can find it again easily.",
    "account.save.not_premium": "Saving a result does not change access to paid reports.",
    "account.save.saving": "Saving…",
    "account.save.saved": "Saved to your account",
    "account.save.saved_detail": "This result is now available in My Results.",
    "account.claim.authentication": "Your account session ended. Sign in again to save this result.",
    "account.claim.invalid": "This result can no longer be saved to an account.",
    "account.claim.conflict": "This result has already been saved to another account.",
    "account.claim.network": "The result was not saved. Check your connection and try again.",
    "account.results.description": "All the results you've saved, in one place.",
    "account.results.empty_title": "No saved results yet",
    "account.results.empty_description": "Finish a test and choose “Save my result” to keep it here.",
    "account.results.browse": "Browse tests",
    "account.results.untitled": "Reflection test",
    "account.results.saved": "Saved",
    "account.results.paid_note": "Access to paid reports is still checked separately.",
    "account.results.open": "Open result",
    "account.results.error": "Your saved results cannot be loaded right now.",
    "account.results.retry": "Try again",
    "account.results.remove": "Remove from My Results",
    "account.results.remove_confirm": "This result will be removed from your account. The anonymous result and any paid-report access stay intact.",
    "account.results.remove_action": "Yes, remove it",
    "account.results.remove_cancel": "Cancel",
    "account.results.removed": "Result removed from your account",
    "account.results.remove_error": "The result could not be removed. Try again.",
    "account.forgot.link": "Forgot password?",
    "account.forgot.title": "Reset your password",
    "account.forgot.description": "Enter your account email. If an account exists, we will send a reset link.",
    "account.forgot.submit": "Send reset link",
    "account.forgot.sent": "If an account with that email exists, reset instructions will be sent.",
    "account.forgot.privacy": "This message is always the same to protect account privacy.",
    "account.forgot.back": "Back to sign in",
    "account.reset.title": "Create a new password",
    "account.reset.description": "Use a new password that you only use for this account.",
    "account.reset.new_password": "New password",
    "account.reset.submit": "Save new password",
    "account.reset.success": "Password updated. Please sign in again.",
    "account.reset.request_new": "Request a new link",
    "account.verify.title": "Verify email",
    "account.verify.description": "We're checking your verification link.",
    "account.verify.working": "Verifying email…",
    "account.verify.success_title": "Email verified",
    "account.verify.success": "Your account email address has been verified.",
    "account.verify.error_title": "This link cannot be used",
    "account.recovery.error.invalid": "This link is invalid, already used, or expired. Request a new link to continue.",
    "account.recovery.error.rate_limit": "Too many attempts. Wait a moment and try again.",
    "account.recovery.error.network": "The link could not be checked. Check your connection and try again.",
    "account.settings.title": "Account settings",
    "account.settings.description": "Manage your email, security, saved results, and account deletion.",
    "account.settings.email_title": "Account email",
    "account.settings.verified": "Email verified",
    "account.settings.unverified": "Email not verified",
    "account.settings.send_verification": "Send verification email",
    "account.settings.verification_sent": "If verification is still needed, a link has been sent. Check your inbox.",
    "account.settings.security_title": "Security",
    "account.settings.security_description": "Reset your password through a secure email link or end the account session on this device.",
    "account.settings.reset_password": "Reset password",
    "account.settings.saved_title": "Saved results",
    "account.settings.saved_description": "View or remove results you've saved to this account.",
    "account.settings.open_results": "Open My Results",
    "account.settings.delete_title": "Delete account",
    "account.settings.delete_description": "This deletes your account and removes your saved results from it. Anonymous results, transactions, and paid-report access are kept and not transferred.",
    "account.settings.current_password": "Current password",
    "account.settings.delete_confirm": "I understand my account will be deleted and my saved results will be removed from it.",
    "account.settings.delete_action": "Delete my account",
    "account.settings.delete_error": "The account could not be deleted. Check your password and try again.",
    "account.settings.deleted": "Account deleted",
    "admin.login": "Admin Sign in",
    "admin.email": "Email",
    "admin.password": "Password",
    "admin.signin": "Sign in",
    "admin.dashboard": "Dashboard",
    "admin.instruments": "Instruments",
    "admin.categories": "Categories",
    "admin.responses": "Responses",
    "admin.settings": "Settings",
    "admin.logout": "Log out",
    "footer.note": "An educational platform for self-exploration.",
  },
};

export function pickLocalized(obj, base, language) {
  if (!obj) return "";
  return obj[`${base}_${language}`] || obj[`${base}_id`] || obj[`${base}_en`] || "";
}

// Public, search-indexed pages carry their language in the URL so Google can
// index each language separately: Indonesian at /..., English at /en/....
// Every other route (questionnaire, results, account, admin) keeps using the
// language stored in localStorage.
const LOCALIZED_PUBLIC_PATH = /^\/(?:instruments(?:\/[^/]+)?)?$/;
export const URL_LANGUAGES = ["id", "en"];

export function stripLanguagePrefix(pathname) {
  if (pathname === "/en") return "/";
  return pathname.startsWith("/en/") ? pathname.slice(3) : pathname;
}

// "en" or "id" when the path is a localized public page, otherwise null.
export function urlLanguage(pathname) {
  const isEnglish = pathname === "/en" || pathname.startsWith("/en/");
  if (!LOCALIZED_PUBLIC_PATH.test(stripLanguagePrefix(pathname))) return null;
  return isEnglish ? "en" : "id";
}

export function localizedPath(path, language) {
  const [, pathname = "/", suffix = ""] = /^([^?#]*)(.*)$/.exec(path || "/");
  const base = stripLanguagePrefix(pathname || "/");
  if (!LOCALIZED_PUBLIC_PATH.test(base)) return path;
  if (language !== "en") return `${base}${suffix}`;
  return `${base === "/" ? "/en" : `/en${base}`}${suffix}`;
}

// hreflang alternates for a localized public path (x-default is Indonesian).
export function localizedAlternates(path) {
  return {
    id: localizedPath(path, "id"),
    en: localizedPath(path, "en"),
    "x-default": localizedPath(path, "id"),
  };
}

function initialLanguage() {
  const fromUrl = typeof window !== "undefined" ? urlLanguage(window.location.pathname) : null;
  return fromUrl || localStorage.getItem("se_lang") || "id";
}

export function LangProvider({ children }) {
  const [lang, setLang] = useState(initialLanguage);
  useEffect(() => { localStorage.setItem("se_lang", lang); }, [lang]);
  useEffect(() => { document.documentElement.lang = lang; }, [lang]);
  const lp = (path) => localizedPath(path, lang);
  const t = (key, vars = {}) => {
    let s = (dict[lang] && dict[lang][key]) || key;
    Object.entries(vars).forEach(([k, v]) => { s = s.replaceAll(`{${k}}`, v); });
    return s;
  };
  const pick = (obj, base) => pickLocalized(obj, base, lang);
  return (
    <LangContext.Provider value={{ lang, setLang, t, pick, lp }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used inside LangProvider");
  return ctx;
}
